<template>
  <div>
    <b-table responsive
             :fields="permissionFields"
             :items="items">
      <template v-for="(myApp, i) in apps" v-slot:[`head(${field.key})`]="{ row }">
        <b-avatar
            :src="myApp.imgURL"
            variant="warning"
            rounded
        />
       <span>{{myApp.name}}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name:"HeartBeat_PermissionsTable",
  mounted() {
    this.getMyApps();
  },
  computed: {
    ...mapGetters({
      apps: "user/apps",
      family: "user/family"
    }),
    permissionFields(){
      return [  { key: 'myapp', label: 'Full Name' },
                { key: 'myapp', label: 'Full Name' },
                { key: 'myapp', label: 'Full Name' }
      ];
    }
  },
  methods: {
    getMyApps() {
      this.$store.dispatch("user/getListApps").then(() => {

      }).catch((err) => {

      });
    },
  },
  data() {
    return {
      items: [
        {
          heading1: 'table cell',
          heading2: 'table cell',
          heading3: 'table cell',
          heading4: 'table cell',
          heading5: 'table cell',
          heading6: 'table cell',
          heading7: 'table cell',
          heading8: 'table cell',
          heading9: 'table cell',
          heading10: 'table cell',
          heading11: 'table cell',
          heading12: 'table cell'
        },
        {
          heading1: 'table cell',
          heading2: 'table cell',
          heading3: 'table cell',
          heading4: 'table cell',
          heading5: 'table cell',
          heading6: 'table cell',
          heading7: 'table cell',
          heading8: 'table cell',
          heading9: 'table cell',
          heading10: 'table cell',
          heading11: 'table cell',
          heading12: 'table cell'
        },
        {
          heading1: 'table cell',
          heading2: 'table cell',
          heading3: 'table cell',
          heading4: 'table cell',
          heading5: 'table cell',
          heading6: 'table cell',
          heading7: 'table cell',
          heading8: 'table cell',
          heading9: 'table cell',
          heading10: 'table cell',
          heading11: 'table cell',
          heading12: 'table cell'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
